var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { defaultMessageFieldCpfError, defaultMessageFieldError, useRequerimentoContext, flagCpfDuplicado, } from "../../modules/Requerimento/Cadastro/context/RequerimentoContext";
import debounce from "lodash.debounce";
import { CustomInputForm } from "../Forms/CustomInputForm";
import { isValidCpf, normalizeCpf } from "../../modules/utils/documentoValidators";
export var CpfValidator = function (_a) {
    var name = _a.name, _b = _a.value, value = _b === void 0 ? "" : _b, InputProps = _a.InputProps, entity = _a.entity, onChange = _a.onChange, setCpfValid = _a.setCpfValid, props = __rest(_a, ["name", "value", "InputProps", "entity", "onChange", "setCpfValid"]);
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useRequerimentoContext(), _requerimento = _d._requerimento, activeStep = _d.activeStep;
    var requerimento = _requerimento[0];
    var isCpfValid = function (cpf) {
        var digitsOnly = normalizeCpf(cpf !== null && cpf !== void 0 ? cpf : "");
        return isValidCpf(digitsOnly);
    };
    var safeFieldErrorChange = function (update) {
        if (props.fieldErrorChange && props.fieldsErrors) {
            try {
                props.fieldErrorChange(__assign(__assign({}, props.fieldsErrors), update));
            }
            catch (e) {
                // swallow
            }
        }
    };
    var clearFieldErrorUnlessRequired = function (fieldName) {
        var _a;
        var _b, _c;
        var current = "".concat((_c = (_b = props.fieldsErrors) === null || _b === void 0 ? void 0 : _b[fieldName]) !== null && _c !== void 0 ? _c : "");
        if (!current.startsWith(defaultMessageFieldError)) {
            safeFieldErrorChange((_a = {}, _a[fieldName] = "", _a));
        }
    };
    var makeDuplicateMessage = function (duplicates) {
        if (duplicates.length === 1)
            return duplicates[0].message;
        var labels = {
            CONJUGE_REPRESENTANTE: "Cônjuge do Representante Legal",
            PESSOA_FALECIDA: "Pessoa Falecida",
            INVENTERIANTE: "Inventariante",
            REPRESENTANTE: "Representante Legal",
            CONJUGE_REQUERENTE: "Cônjuge do Requerente",
            PROCURADOR: "Procurador",
            REQUERENTE: "Requerente",
        };
        var names = duplicates.map(function (d) { var _a; return (_a = labels[d.profile]) !== null && _a !== void 0 ? _a : d.profile; });
        var joined = names.length === 2
            ? "".concat(names[0], " e ").concat(names[1])
            : "".concat(names.slice(0, -1).join(", "), " e ").concat(names[names.length - 1]);
        return "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo ").concat(joined, ".");
    };
    var validateCpf = debounce(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var cpfDigits, fieldName, refs, profileMap, currentProfile, duplicates, message;
        var _a, _b, _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        return __generator(this, function (_1) {
            cpfDigits = normalizeCpf(value !== null && value !== void 0 ? value : "");
            fieldName = (_d = props.fieldErrorName) !== null && _d !== void 0 ? _d : "cpfError";
            if (!cpfDigits || cpfDigits.length < 11) {
                setError(null);
                setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(false);
                clearFieldErrorUnlessRequired(fieldName);
                return [2 /*return*/];
            }
            if (!isCpfValid(cpfDigits)) {
                setError(defaultMessageFieldCpfError);
                setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(false);
                safeFieldErrorChange((_a = {}, _a[fieldName] = defaultMessageFieldCpfError, _a));
                return [2 /*return*/];
            }
            refs = [
                {
                    cpf: normalizeCpf((_h = (_g = (_f = (_e = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _e === void 0 ? void 0 : _e.representante) === null || _f === void 0 ? void 0 : _f.conjuge) === null || _g === void 0 ? void 0 : _g.cpf) !== null && _h !== void 0 ? _h : ""),
                    profile: "CONJUGE_REPRESENTANTE",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo Conjuge do Representante Legal."),
                },
                {
                    cpf: normalizeCpf((_l = (_k = (_j = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _j === void 0 ? void 0 : _j.pessoaFalecida) === null || _k === void 0 ? void 0 : _k.cpf) !== null && _l !== void 0 ? _l : ""),
                    profile: "PESSOA_FALECIDA",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pela Pessoa Falecida."),
                },
                {
                    cpf: normalizeCpf((_p = (_o = (_m = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _m === void 0 ? void 0 : _m.inventariante) === null || _o === void 0 ? void 0 : _o.cpf) !== null && _p !== void 0 ? _p : ""),
                    profile: "INVENTERIANTE",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo Inventariante."),
                },
                {
                    cpf: normalizeCpf((_s = (_r = (_q = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _q === void 0 ? void 0 : _q.representante) === null || _r === void 0 ? void 0 : _r.cpf) !== null && _s !== void 0 ? _s : ""),
                    profile: "REPRESENTANTE",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo Representante Legal."),
                },
                {
                    cpf: normalizeCpf((_v = (_u = (_t = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _t === void 0 ? void 0 : _t.conjuge) === null || _u === void 0 ? void 0 : _u.cpf) !== null && _v !== void 0 ? _v : ""),
                    profile: "CONJUGE_REQUERENTE",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo Conjuge do Requerente."),
                },
                {
                    cpf: normalizeCpf((_y = (_x = (_w = requerimento === null || requerimento === void 0 ? void 0 : requerimento.procurador) === null || _w === void 0 ? void 0 : _w.pessoaFisica) === null || _x === void 0 ? void 0 : _x.cpf) !== null && _y !== void 0 ? _y : ""),
                    profile: "PROCURADOR",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo Procurador."),
                },
                {
                    cpf: normalizeCpf((_0 = (_z = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _z === void 0 ? void 0 : _z.cpf) !== null && _0 !== void 0 ? _0 : ""),
                    profile: "REQUERENTE",
                    message: "".concat(flagCpfDuplicado, " este CPF j\u00E1 se encontra em uso pelo Requerente."),
                },
            ];
            profileMap = {
                requerentePf: "REQUERENTE",
                procurador: "PROCURADOR",
                requerimentoInventariante: "INVENTERIANTE",
                PessoaFalecida: "PESSOA_FALECIDA",
                conjugeRequerente: "CONJUGE_REQUERENTE",
                conjugeRepresentante: "CONJUGE_REPRESENTANTE",
                representante: "REPRESENTANTE",
            };
            currentProfile = profileMap[entity];
            duplicates = refs.filter(function (r) {
                var isSameCpf = r.cpf && r.cpf === cpfDigits && r.profile !== currentProfile;
                if (!isSameCpf)
                    return false;
                var isEtapaResponsavelTecnico = activeStep > 0;
                if (isEtapaResponsavelTecnico) {
                    if (r.profile === "PROCURADOR" || r.profile === "INVENTERIANTE") {
                        return false;
                    }
                }
                return true;
            });
            if (duplicates.length > 0) {
                message = makeDuplicateMessage(duplicates);
                setError(message);
                setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(false);
                safeFieldErrorChange((_b = {}, _b[fieldName] = message, _b));
                return [2 /*return*/];
            }
            setError(null);
            setCpfValid === null || setCpfValid === void 0 ? void 0 : setCpfValid(true);
            safeFieldErrorChange((_c = {}, _c[fieldName] = "", _c));
            return [2 /*return*/];
        });
    }); }, 500);
    useEffect(function () {
        validateCpf(value);
        return function () {
            validateCpf.cancel();
        };
    }, [value, requerimento, entity, setCpfValid, validateCpf]);
    var errorMessage = useMemo(function () {
        var _a;
        return (_a = error !== null && error !== void 0 ? error : props === null || props === void 0 ? void 0 : props.helperText) !== null && _a !== void 0 ? _a : "";
    }, [error, props === null || props === void 0 ? void 0 : props.helperText]);
    return (_jsx(CustomInputForm, __assign({ sx: { width: "100%", textAlign: "left" }, InputProps: __assign({}, InputProps), helperText: errorMessage, error: !!errorMessage, onChange: onChange, value: value, name: name }, props)));
};
